import React, { Component } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import RegistrationTicketItem from './RegistrationTicketItem';
import cls from 'classnames';

export function TitleWithTooltip({id}) {
    return (
        <OverlayTrigger
            overlay={<Tooltip id={id}>Session registration and availability is determined by ticket type. Each ticket
                will allow you to register for specific sessions based on its terms.</Tooltip>}
            placement="bottom"
            delayShow={300}
            delayHide={150}
        >
            <span>Select all tickets you wish to register to session with</span>
        </OverlayTrigger>
    );
}

export class TicketSelectionPopover extends Component{

    selectTicketAction = (ticketId) => {
        const {
            selectTicketByUser,
            selectedTicketsIds,
            eventId
        } = this.props;
        if (selectedTicketsIds.length === 1 && selectedTicketsIds.includes(parseInt(ticketId))) return;
        selectTicketByUser(ticketId, eventId);
    }

    render() {
        const {
            className,
            style: {
                top,
                left
            },
            arrowOffsetLeft = null,
            arrowOffsetTop = null,
            positionTop,
            positionLeft,
            userData: {
                userName,
                primaryEmail
            },
            tickets,
            openCloseTicketSelectionPopUp,
            selectedTicketsIds,
            selectTicketByUser,
            eventId,
            color1,
            ...rest
        } = this.props;
        const classDoneButton = cls('done-ticket-selection color-1-background color-1-border custom-color');
        const mainPopUpStyle = {top, right: 0};

        return (
            <div
                className={`ticket-selection-popover ${className}`}
                style={mainPopUpStyle}
                {...rest}>
                <div className='popover-arrow-custom' />
                <div className='user-data-section'>
                    <div className='ticket-count-section'>
                        <span className='tickets-counter'>
                            <TitleWithTooltip id="ticket-selection-popover-title"/>
                        </span>
                    </div>
                    <div className='user-email-section'>
                        <span className='user-name'>
                            <span className='user-email'>{primaryEmail}</span>
                        </span>
                    </div>
                </div>
                <div className='wrapper-for-mobile-view'>
                    <div className="tickets-selection-section">
                        {tickets.map(({id, ticketName}) => <RegistrationTicketItem
                            onClick={this.selectTicketAction.bind(this, id)}
                            color1={color1}
                            key={id}
                            active={selectedTicketsIds.includes(id)}
                            ticketName={ticketName}
                            id={id} />) }
                    </div>
                </div>
                <div className="button-done-wrapper padding-top-small">
                    <button
                        onClick={openCloseTicketSelectionPopUp}
                        className={classDoneButton}>
                        Done
                    </button>
                </div>
            </div>
        );
    }
}
